export default __webpack_public_path__ + "9d511a643b28f3b0830c036602c58f5f.svg";